import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";
import { useNavigate } from "react-router-dom";
import { Puff } from "react-loader-spinner";
import { FaArrowUp } from "react-icons/fa";


const EditMenuItems = ({}) => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restaurantData, setRestaurantData] = useState({});
  const [foodCategories, setFoodCategories] = useState([]);
  const [showButton, setShowButton] = useState(false);

  const [menuAdding, setMenuAdding] = useState(false);

  const [newMenuItem, setNewMenuItem] = useState({
    name: "",
    price: 0,
    description: "",
    extras: [{ name: "", price: "" }],
    imageUrl: "",
    menuCategory: "", // Add category field
  });
 useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // Load restaurant data from local storage
  useEffect(() => {
    const localUserData = JSON.parse(localStorage.getItem("user"));
    if (localUserData) {
      setRestaurantData(localUserData);
    }else{
      window.location.href = "/login";
    }
  }, []);

  
    const fetchMenuItems = async () => {
      try {
        console.log("restaurantData", restaurantData);
        console.log("restaurantData restaurantId", restaurantData.restaurantId);

        const response = await axiosInstance.get(
          `/api/menu-items?restaurantId=${restaurantData.restaurantId}`
        ); 
        setMenuItems(response.data);
      } catch (error) {
        console.error("Error fetching menu items:", error);
      } finally {
        setLoading(false);
      }
    }; 

     useEffect(() => {
        if (restaurantData.restaurantId) {
          fetchMenuItems();
        }
      }, [restaurantData.restaurantId]);

  // Fetch food categories from restaurant data
  useEffect(() => {
    const fetchFoodCategories = async () => {
      if (restaurantData.restaurantId) {
        try {
          const response = await axiosInstance.get(
            `/api/restaurant/menu-categories?restaurantId=${restaurantData.restaurantId}`
          );

          console.log("response", response.data);
          setFoodCategories(response.data.categories);
          if (response.data.length !== 0) {
            // Update local storage with menuCategoriesAdded
            const localUserData = JSON.parse(localStorage.getItem("user"));
            localUserData.menuCategoriesAdded = true;
            localStorage.setItem("user", JSON.stringify(localUserData));
          }
        } catch (error) {
          console.error("Error fetching food categories:", error);
        }
      }
    };
    fetchFoodCategories();
  }, [restaurantData]);

  const MarkAsAvailable = async (id, available) => {
    try {
      await axiosInstance.put(`/api/menu-items/${id}`, {
        available: !available,
      });
      setMenuItems((prevItems) =>
        prevItems.map((item) =>
          item._id === id ? { ...item, available: !available } : item
        )
      );
    } catch (error) {
      console.error("Error updating menu item availability:", error);
    }
  };

  const deleteMenuItem = async (id) => {
    try {
      await axiosInstance.delete(`/api/menu-items/${id}`);
      setMenuItems((prevItems) => prevItems.filter((item) => item._id !== id));

      // Update the local storage with menuAdded
      const localUserData = JSON.parse(localStorage.getItem("user"));
      const menuItems = await axiosInstance.get(
        `/api/menu-items?restaurantId=${localUserData.restaurantId}`
      );
      if (menuItems.data.length === 0) {
        localUserData.menuAdded = false;
      } else {
        localUserData.menuAdded = true;
      }
      localStorage.setItem("user", JSON.stringify(localUserData));
    } catch (error) {
      console.error("Error deleting menu item:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewMenuItem((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleExtraChange = (index, e) => {
    const { name, value } = e.target;
    const updatedExtras = [...newMenuItem.extras];
    updatedExtras[index][name] = value;
    setNewMenuItem((prevState) => ({
      ...prevState,
      extras: updatedExtras,
    }));
  };

  const addExtraField = () => {
    setNewMenuItem((prevState) => ({
      ...prevState,
      extras: [...prevState.extras, { name: "", price: "" }],
    }));
  };

  const removeExtraField = (index) => {
    const updatedExtras = newMenuItem.extras.filter((_, i) => i !== index);
    setNewMenuItem((prevState) => ({
      ...prevState,
      extras: updatedExtras,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setMenuAdding(true);

      const response = await axiosInstance.post("/api/menu-items", {
        ...newMenuItem,
        restaurantId: restaurantData.restaurantId,
      });
      setMenuItems((prevItems) => [...prevItems, response.data]);

      // Update local storage with menuAdded
      const localUserData = JSON.parse(localStorage.getItem("user"));
      localUserData.menuAdded = true;
      localStorage.setItem("user", JSON.stringify(localUserData));

      // Clear the form after submission
      setNewMenuItem({
        name: "",
        price: "",
        description: "",
        extras: [{ name: "", price: "" }],
        imageUrl: "",
        menuCategory: "",  
      });
      setMenuAdding(false);
    } catch (error) {
      console.error("Error adding menu item:", error);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-4 border border-gray-300 rounded shadow-lg bg-white">
       {showButton && (
              <button
                onClick={scrollToTop}
                className="fixed bottom-5 right-5 p-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
                style={{
                  background: "linear-gradient(to right, #6A5ACD, #00BFFF)", // Gradient color
                  color: "white",
                  zIndex: 1000,
                }}
              >
                <FaArrowUp size={20} /> {/* FontAwesome arrow up icon */}
              </button>
            )}
      <h2 className="text-2xl font-bold mb-4">Manage Menu Items</h2>

      <h3 className="text-xl font-semibold mb-2">Add New Menu Item</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700" htmlFor="name">
            Item Name
          </label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="pizza, burger, etc."
            value={newMenuItem.name}
            onChange={handleChange}
            required
            className=" w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700" htmlFor="price">
            Price
          </label>
          <input
            type="number"
            name="price"
            id="price"
            value={newMenuItem.price}
            onChange={handleChange}
            required
            className=" w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700" htmlFor="description">
            Description
          </label>
          <textarea
            name="description"
            id="description"
            value={newMenuItem.description}
            onChange={handleChange}
            required
            placeholder="Food description like ingredients..."
            className=" w-full bg-white mt-2 text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            maxLength={250} // Limiting the description to 250 characters
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700" htmlFor="category">
            Category
          </label>
          <select
            name="menuCategory"
            id="menuCategory"
            value={newMenuItem.menuCategory}
            onChange={handleChange}
            required
            className="mt-1 block w-full border bg-white border-gray-300 rounded-md p-2"
          >
            <option value="">Select a category</option>
            {foodCategories.map((category, index) => (
              <option key={index} value={category._id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        {newMenuItem.extras.map((extra, index) => (
          <div key={index} className="mb-4 flex justify-between">
            <div className="w-1/2 mr-2">
              <label
                className="block text-gray-700"
                htmlFor={`extra-name-${index}`}
              >
                Extra Name
              </label>
              <input
                type="text"
                name="name"
                placeholder="Ice, Cheese, Large size etc."
                id={`extra-name-${index}`}
                value={extra.name}
                onChange={(e) => handleExtraChange(index, e)}
                className="w-full mt-1 bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="w-1/2">
              <label
                className="block text-gray-700"
                htmlFor={`extra-price-${index}`}
              >
                Extra Price
              </label>
              <input
                type="number"
                name="price"
                id={`extra-price-${index}`}
                value={extra.price}
                onChange={(e) => handleExtraChange(index, e)}
                className="mt-1 w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              type="button"
              onClick={() => removeExtraField(index)}
              className="text-red-500 ml-2 mt-4"
            >
              Remove
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addExtraField}
          className="bg-blue-500 text-white rounded p-2 mb-4"
        >
          Add More Extras
        </button>

        {/* <div className="mb-4">
             <label className="block text-gray-700" htmlFor="imageUrl">
               Image URL
             </label>
             <input
               type="text"
               name="imageUrl"
               id="imageUrl"
               value={newMenuItem.imageUrl}
               onChange={handleChange}
               className="mt-1 w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
             />
           </div> */}
        <div className="mb-4">
          <label className="block text-gray-700" htmlFor="imageUrl">
            Image URL
          </label>
          <div className="relative">
            <input
              type="text"
              name="imageUrl"
              id="imageUrl"
              value={newMenuItem.imageUrl}
              onChange={handleChange}
              className="mt-1 w-full bg-white text-black border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter image URL (e.g., from Google Images)"
            />
            <div className="absolute top-1 right-1">
              <span
                className="cursor-pointer text-blue-500"
                title="Tip: Use an image URL from Google Images if your restaurant doesn't have professional photos. We are currently adding an image upload option."
              >
                ℹ️
              </span>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="bg-green-500 text-white rounded p-2"
          disabled={menuAdding}
        >
          {menuAdding ? (
            <Puff
              height="20"
              width="20"
              color="white"
              ariaLabel="loading"
              visible={true}
            />
          ) : (
            "Add item to the Menu"
          )}
        </button>
      </form>

      <div className="mb-4">
        <h3 className="text-xl font-semibold mb-2">Existing Menu Items</h3>
        {menuItems.length > 0 ? (
          <ul className="space-y-4">
            {menuItems.map((item) => (
              <li
                key={item._id}
                className="flex justify-between items-center p-4 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition-shadow duration-300"
              >
                <div className="flex items-start space-x-4">
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="w-20 h-20 object-cover rounded-lg shadow"
                    />
                  )}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-600">
                      <span className="font-bold">Description: </span>
                      {item.description}
                    </p>
                    <p className="text-sm font-medium text-gray-800 mt-1">
                      <span className="font-bold">Price: </span>${item.price}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-bold">Category: </span>
                      {item.menuCategory.name}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-bold">Availability: </span>
                      {item.available ? "Available" : "Unavailable"}
                    </p>

                    <div className="mt-2">
                      <span className="font-bold text-gray-800">Extras: </span>
                      {item.extras &&
                      item.extras.length > 0 &&
                      item.extras.some(
                        (extra) => extra.name && extra.price !== null
                      ) ? (
                        <ul className="list-disc list-inside text-sm text-gray-600">
                          {item.extras
                            .filter(
                              (extra) => extra.name && extra.price !== null
                            )
                            .map((extra, index) => (
                              <li key={index}>
                                <span>{extra.name}</span>: ${extra.price}
                              </li>
                            ))}
                        </ul>
                      ) : (
                        <span className="text-sm text-gray-500">
                          No extras available
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => MarkAsAvailable(item._id, item.available)}
                    className="text-white font-medium  bg-blue-500 p-2 mb-2  duration-200 mr-2 rounded-lg"
                  >
                    {item.available ? "Unavailable" : "Available"}
                  </button>
                  <button
                    onClick={() => deleteMenuItem(item._id)}
                    className="bg-red-400 text-white  p-2  mb-2   font-medium transition-colors duration-200 rounded-lg"
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No menu items available.</p>
        )}
      </div>

     
    </div>
  );
};

export default EditMenuItems;
